import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { useIsOverflowing } from '../../utils/hooks/useIsOverflowing';
import { ActionsStyle, CardStyle, TextStyle, TitleStyle } from './styled';

export interface IBulletinMessageCompProps {
  messageDateTime?: string,
  message?: string,
  closeHandler?: () => void,
}

export const BulletinMessageComp = ({
  messageDateTime = '',
  message = '',
  closeHandler
}: IBulletinMessageCompProps) => {
  const [expanded, setExpanded] = useState<boolean>(false);
  const [show, setShow] = useState(true);
  const handleExpanded = () => setExpanded(!expanded);
  const [containerRef, isOverflowing] = useIsOverflowing();

  const onClose = () => {
    if (closeHandler) {
      closeHandler();
    }
    setShow(false);
  }

  return (
    <Card className={show ? '' : 'hidden'} sx={CardStyle} variant="outlined">
      <CardContent sx={{ padding: `16px 0 0` }}>
        <Typography sx={TitleStyle} color="text.secondary" gutterBottom>
          {messageDateTime}
        </Typography>
        <Typography
          dangerouslySetInnerHTML={{ __html: message }}
          ref={containerRef}
          sx={TextStyle}
          className={expanded ? 'expanded' : ''} variant="body2"
        />
      </CardContent>
      <CardActions sx={ActionsStyle}>
        <Button variant="text" onClick={onClose} size="small">Close</Button>
        {isOverflowing && <Button onClick={handleExpanded} size="small">
          See {expanded ? 'Less' : 'More'}
        </Button>}
      </CardActions>
    </Card>
  );
}